import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import CompanyContact from '@business/general/CompanyContact';
import EventRoomTranslationGenerated from './EventRoomTranslation.generated';
import EventRoomTranslation from '../EventRoomTranslation';


export class EventRoomGeneratedEntityManager<BT extends EventRoomTranslationGenerated, B extends EventRoomGenerated<BT>> extends EntityWithTranslationManager<BT, B>
{
	translationEntityClass: any = EventRoomTranslation;

    constructor(parameters: EntityWithTranslationManagerParameters<BT, B>)
    {
        super({
            name: parameters.name ?? 'EventRoom',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'isActive', type: BusinessEntityFieldType.Boolean },
				{ name: 'capacityForBanquet', type: BusinessEntityFieldType.Integer },
				{ name: 'capacityForCocktail', type: BusinessEntityFieldType.Integer },
				{ name: 'capacityForBoardRoom', type: BusinessEntityFieldType.Integer },
				{ name: 'capacityForUStyle', type: BusinessEntityFieldType.Integer },
				{ name: 'capacityForClassroom', type: BusinessEntityFieldType.Integer },
				{ name: 'capacityForTheater', type: BusinessEntityFieldType.Integer },
				{ name: 'dimensions', type: BusinessEntityFieldType.VarChar },
				{ name: 'surfaceArea', type: BusinessEntityFieldType.Decimal },
				{ name: 'height', type: BusinessEntityFieldType.Decimal },
				{ name: 'defaultContact', type: BusinessEntityFieldType.ForeignKey, inputName: 'defaultContactId', inputProperty: 'defaultContact.id', relatedManager: CompanyContact.manager },
				{ name: 'orderNo', type: BusinessEntityFieldType.Integer, isInput: false },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'eventRooms',
            translationsCustomGraphQlFields: 'name,description,shortDescription,seoTitle,seoDescription,seoKeywords,slug',
        });
    }

}
export class EventRoomGenerated<BT extends EventRoomTranslationGenerated> extends BusinessEntityWithTranslation<BT>
{
	/** Whether the event room is active. */
	isActive: boolean = true;
	/** Banquet capacity. */
	capacityForBanquet!: number;
	/** Cocktail capacity. */
	capacityForCocktail!: number;
	/** Board room capacity. */
	capacityForBoardRoom!: number;
	/** U-style capacity. */
	capacityForUStyle!: number;
	/** Classroom capacity. */
	capacityForClassroom!: number;
	/** Theater capacity. */
	capacityForTheater!: number;
	/** Dimensions of the room. */
	dimensions: string = '';
	/** Surface area in square meters. */
	surfaceArea: number | null = null;
	/** Height in meters. */
	height: number | null = null;
	/** Reference to CompanyContact that is the default contact for the event room. */
	defaultContact: CompanyContact | null = null;
	/** The order number of the entity. This is automatically set by the system. The value is updated automatically when the entity is moved up or down in the list. */
	orderNo: number = 0;
	/** The name of the foreign key to the translated entity. */
	translationForeignKeyName: string = 'eventRoom';
	/** The primary language of the entity. */
	primaryLanguage: string = 'ro';

}

export default EventRoomGenerated;